import axios from './axios.js'
import { encode, decode } from 'html-entities'

export default {
    namespaced: true,
    state: {
        chairman: ''
    },
    actions: {
        getChairman ({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/chairman`).then(response => {
                    commit('setChairman', response)
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        putChairmanImage ({dispatch}, data) {
             return new Promise((resolve, reject) => {
                 axios.put(`/api/chairman/image`, {
                     image: data.image
                 }).then(response => {
                     dispatch('getChairman')
                     resolve(response)
                 }).catch(error => {
                     reject(error)
                 })
             })
        },
        putChairman ({dispatch}, data) {
             return new Promise((resolve, reject) => {
                 axios.put(`/api/chairman`, {
                     name: data.name,
                     content: encode(data.content),
                     introduce: encode(data.introduce)
                 }).then(response => {
                     dispatch('getChairman')
                     resolve(response)
                 }).catch(error => {
                     reject(error)
                 })
             })
        }
    },
    mutations: {
        setChairman(state, data){
            data.introduce = decode(data.introduce)
            data.content = decode(data.content)
            data.image = `${process.env.VUE_APP_FILE_SERVER_ADDRESS}${data.image}`
            state.chairman = data
        }
    },
    getters: {
        getChairman: state => {
          return state.chairman
        },
    }
}
